<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;">
      <header class="panel-heading" style="padding: 10px;">
        <h4 class="panel-title">同步學期設定</h4>
      </header>
      <div class="panel-body">
        <div class="row form-group">
          <div class="col-md-3">
            <label class="col-md-5">目前同步學期</label>
            <div class="col-md-7">
              <span>{{ syncSmtrDisplay }}</span>
            </div>
          </div>
          <div class="col-md-3">
            <label class="col-md-4">學年度</label>
            <div class="col-md-8">
              <select class="form-control" v-model="syncForm.schYear">
                <option :value="null">請選擇</option>
                <option v-for="item in schYearList" :key="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <label class="col-md-4">學期</label>
            <div class="col-md-8">
              <select class="form-control" v-model="syncForm.semester">
                <option :value="null">請選擇</option>
                <option :value="1">1</option>
                <option :value="2">2</option>
              </select>
            </div>
          </div>
          <div class="col-md-3 text-right">
            <button type="button" class="btn btn-primary" style="margin-right: 8px;" @click="saveSyncSetting">儲存設定</button>
            <button type="button" class="btn btn-default" @click="exportCsv">匯出 card.csv</button>
          </div>
        </div>
      </div>
    </section>

    <section class="panel panel-default" style="margin-bottom: 0px;">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#accessCardSearchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="accessCardSearchArea" class="panel-collapse collapse in">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-4">
              <label class="col-md-4">學年度</label>
              <div class="col-md-8">
                <select class="form-control" v-model="qryParam.schYear">
                  <option :value="null">請選擇</option>
                  <option v-for="item in schYearList" :key="item" :value="item">{{ item }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">學期</label>
              <div class="col-md-8">
                <select class="form-control" v-model="qryParam.semester">
                  <option :value="null">請選擇</option>
                  <option v-for="item in semesterList" :key="item" :value="item">{{ item }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">卡號</label>
              <div class="col-md-8">
                <input type="text" class="form-control" v-model.trim="qryParam.cardNo">
              </div>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-4">
              <label class="col-md-4">學號</label>
              <div class="col-md-8">
                <input type="text" class="form-control" v-model.trim="qryParam.account">
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">姓名</label>
              <div class="col-md-8">
                <input type="text" class="form-control" v-model.trim="qryParam.name">
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">身份證字號</label>
              <div class="col-md-8">
                <input type="text" class="form-control" v-model.trim="qryParam.idno">
              </div>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-4">
              <label class="col-md-4">房號</label>
              <div class="col-md-8">
                <input type="text" class="form-control" v-model.trim="qryParam.roomNo">
              </div>
            </div>
            <div class="col-md-4">
              <label class="col-md-4">實際編碼</label>
              <div class="col-md-8">
                <input type="text" class="form-control" v-model.trim="qryParam.actualCode">
              </div>
            </div>
            <div class="col-md-4 text-right">
              <div class="col-xs-5 col-md-4 col-md-offset-2">
                <button type="button" class="btn btn-default btn-block" @click="clearSearch">清空</button>
              </div>
              <div class="col-xs-5 col-md-4 col-xs-offset-2 col-md-offset-2">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">宿舍管控卡片設定</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row form-group">
          <div class="col-md-12 text-right">
            <input ref="importFile" type="file" accept=".xlsx,.xls" style="display: none;" @change="importFile" />

            <button type="button" class="btn btn-default hidden-xs" style="margin-right: 8px;" @click="downloadImportTemplate">範本下載</button>
            <button type="button" class="btn btn-default hidden-xs" style="margin-right: 8px;" @click="triggerImport">匯入</button>
            <button type="button" class="btn btn-danger hidden-xs" @click="goCreate">新增</button>

            <button type="button" class="btn btn-default btn-block visible-xs" style="margin-bottom: 8px;" @click="downloadImportTemplate">範本下載</button>
            <button type="button" class="btn btn-default btn-block visible-xs" style="margin-bottom: 8px;" @click="triggerImport">匯入</button>
            <button type="button" class="btn btn-danger btn-block visible-xs" @click="goCreate">新增</button>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center" width="6%">學年度</th>
                  <th class="text-center" width="5%">學期</th>
                  <th class="text-center" width="7%">卡號</th>
                  <th class="text-center" width="8%">卡片模式</th>
                  <th class="text-center" width="8%">姓名</th>
                  <th class="text-center" width="8%">部門(房號)</th>
                  <th class="text-center" width="10%">員工編號(學號)</th>
                  <th class="text-center" width="6%">門組</th>
                  <th class="text-center" width="6%">時區</th>
                  <th class="text-center" width="10%">身份證字號</th>
                  <th class="text-center" width="10%">期限日期</th>
                  <th class="text-center" width="10%">實際編碼</th>
                  <th class="text-center" width="5%">性別</th>
                  <th class="text-center" width="8%">進出管制</th>
                  <th class="text-center" width="8%">樓層管制</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!cardList.length">
                  <td colspan="15" class="text-center">查無資料</td>
                </tr>
                <tr v-for="item in cardList" :key="item.id">
                  <td class="text-center" data-title="學年度">{{ item.schYear }}</td>
                  <td class="text-center" data-title="學期">{{ item.semester }}</td>
                  <td class="text-center" data-title="卡號">{{ item.cardNo }}</td>
                  <td class="text-center" data-title="卡片模式">{{ item.cardMode }}</td>
                  <td class="text-center" data-title="姓名"><a href="javascript:;" @click="goEdit(item)">{{ item.name }}</a></td>
                  <td class="text-center" data-title="部門(房號)">{{ item.roomNo }}</td>
                  <td class="text-center" data-title="員工編號(學號)">{{ item.account }}</td>
                  <td class="text-center" data-title="門組">{{ item.doorGroup }}</td>
                  <td class="text-center" data-title="時區">{{ item.timeZone }}</td>
                  <td class="text-center" data-title="身份證字號">{{ item.idno }}</td>
                  <td class="text-center" data-title="期限日期">{{ item.expireDateStr }}</td>
                  <td class="text-center" data-title="實際編碼">{{ item.actualCode }}</td>
                  <td class="text-center" data-title="性別">{{ item.sex }}</td>
                  <td class="text-center" data-title="進出管制">{{ item.entryControlText }}</td>
                  <td class="text-center" data-title="樓層管制">{{ item.floorControlText }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <div class="text-center">
              <pageControl :page="page" :total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global bootbox */

function buildSchYearList() {
  const list = [];
  let currentYear = new Date().getFullYear() - 1911;
  for (let year = currentYear + 1; year >= 100; year -= 1) {
    list.push(year);
  }
  return list;
}

function defaultQuery() {
  return {
    schYear: null,
    semester: null,
    cardNo: "",
    account: "",
    name: "",
    idno: "",
    roomNo: "",
    actualCode: "",
  };
}

export default {
  data() {
    return {
      cardList: [],
      schYearList: buildSchYearList(),
      semesterList: [1, 2],
      page: 1,
      pageSize: 10,
      totalPage: 0,
      qryParam: defaultQuery(),
      syncForm: { schYear: null, semester: null },
      syncSmtrDisplay: "（未設定）",
    };
  },
  async mounted() {
    if (!this.guardAccess()) {
      return;
    }
    await this.loadSyncSetting();
    this.restoreSearch();
    this.getGridData();
  },
  methods: {
    guardAccess() {
      if (this.isAdmin("stay")) {
        return true;
      }
      bootbox.alert("無宿舍管控卡片設定權限", () => {
        this.$router.replace({ name: "stay.list" });
      });
      return false;
    },    async loadSyncSetting() {
      const resp = await this.$axios.get("/api/DormitoryAccessCard/syncSetting");
      if (resp.data.status === "success" && resp.data.data) {
        this.syncForm.schYear = resp.data.data.schYear;
        this.syncForm.semester = resp.data.data.semester;
        this.syncSmtrDisplay = `${resp.data.data.schYear} 學年第 ${resp.data.data.semester} 學期`;
      }
    },
    async saveSyncSetting() {
      if (!this.syncForm.schYear || !this.syncForm.semester) {
        bootbox.alert("請選擇學年度與學期");
        return;
      }
      const resp = await this.$axios.post(
        "/api/DormitoryAccessCard/syncSetting",
        JSON.stringify({ schYear: this.syncForm.schYear, semester: this.syncForm.semester }),
        { headers: { "Content-Type": "application/json" } }
      );
      bootbox.alert(resp.data.status === "success" ? "設定儲存成功" : resp.data.msg || "儲存失敗", () => {
        if (resp.data.status === "success") this.loadSyncSetting();
      });
    },
    exportCsv() {
      this.$http.get("/api/DormitoryAccessCard/exportCsv", { responseType: "arraybuffer" }).then((res) => {
        this.download2File(res);
      });
    },    restoreSearch() {
      const storeQryParam = JSON.parse(this.getStore(this.$route.name + ".qryParam") || "null");
      if (!storeQryParam) {
        return;
      }

      this.qryParam = {
        ...defaultQuery(),
        ...storeQryParam,
      };
      this.page = storeQryParam.page || 1;
    },
    buildSearchRequest() {
      return {
        page: this.page,
        pageSize: this.pageSize,
        model: {
          schYear: this.qryParam.schYear ? Number(this.qryParam.schYear) : null,
          semester: this.qryParam.semester ? Number(this.qryParam.semester) : null,
          cardNo: this.qryParam.cardNo,
          account: this.qryParam.account,
          name: this.qryParam.name,
          idno: this.qryParam.idno,
          roomNo: this.qryParam.roomNo,
          actualCode: this.qryParam.actualCode,
        },
      };
    },
    updateGrid(page) {
      this.page = page;
      this.getGridData();
    },
    getGridData() {
      this.setStore(this.$route.name + ".qryParam", {
        ...this.qryParam,
        page: this.page,
      });

      this.$axios.post("/api/DormitoryAccessCard/grid", JSON.stringify(this.buildSearchRequest())).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "取得宿舍管控卡片清單失敗");
          return;
        }

        this.cardList = resp.data.data.rows || [];
        this.page = resp.data.data.page || this.page;
        this.totalPage = resp.data.data.total || 0;
      });
    },
    clearSearch() {
      this.qryParam = defaultQuery();
      this.page = 1;
    },
    goCreate() {
      this.$router.push({ name: "stay.accessCard.edit" });
    },
    goEdit(item) {
      this.$router.push({ name: "stay.accessCard.edit", query: { id: item.id } });
    },
    triggerImport() {
      if (!this.isAdmin("stay")) {
        bootbox.alert("無權限操作");
        return;
      }
      this.$refs.importFile.click();
    },
    importFile(e) {
      if (!e.target.files || e.target.files.length === 0) {
        return;
      }
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);

      this.$axios.post("/api/DormitoryAccessCard/import", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      }).then((resp) => {
        bootbox.alert(resp.data.msg || (resp.data.status === "success" ? "匯入成功" : "匯入失敗"), () => {
          if (resp.data.status === "success") {
            this.updateGrid(1);
          }
        });
      });

      e.target.value = "";
    },
    downloadImportTemplate() {
      this.$http.get("/api/DormitoryAccessCard/importTemplate", { responseType: "arraybuffer" }).then((res) => {
        this.download2File(res);
      });
    },
  },
};
</script>